import { render, staticRenderFns } from "./postTiktok.vue?vue&type=template&id=47e83e60&"
import script from "./postTiktok.vue?vue&type=script&lang=js&"
export * from "./postTiktok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports